import {Component, Input} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Billingservices} from '../../user/model/Billingservices';

@Component({
  selector: 'app-billing-detail',
  templateUrl: './billing-detail.component.html',
  styleUrls: ['./billing-detail.component.css']
})
export class BillingDetailComponent {

  @Input() billingservices: Billingservices;
  public color: string;

  constructor(public modalService: NgbModal) {
    this.color = this.cardColor;
  }

  get random(): number {
    return +Math.random().toFixed(2) * 100;
  }

  get cardColor(): string {
    const code = this.random;
    if (code >= 0 && code < 21) {
      return 'primary';
    } else if (code >= 21 && code < 41) {
      return 'secondary';
    } else if (code >= 41 && code < 61) {
      return 'success';
    } else if (code >= 61 && code < 81) {
      return 'danger';
    } else if (code >= 81 && code < 101) {
      return 'warning';
    } else {
      return 'info';
    }
  }
}
